if (!customElements.get("live-chat-fixed-image")) {
  customElements.define(
    "live-chat-fixed-image",
    class LiveChatFixedImage extends HTMLElement {
      connectedCallback() {
        this.addEventListener("click", this.handleClick.bind(this));
        this.addEventListener("keydown", this.handleKeydown.bind(this));
        this.setupTawkCallbacks();
      }

      handleClick() {
        this.hide();
        this.toggleChat();
      }

      handleKeydown(event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          this.hide();
          this.toggleChat();
        }
      }

      toggleChat() {
        if (window.Tawk_API?.toggle) {
          window.Tawk_API.toggle();
        }
      }

      hide() {
        this.classList.add("is-hidden");
      }

      show() {
        this.classList.remove("is-hidden");
      }

      setupTawkCallbacks() {
        window.Tawk_API = window.Tawk_API || {};

        const previousOnMaximized = window.Tawk_API.onChatMaximized;
        const previousOnMinimized = window.Tawk_API.onChatMinimized;

        window.Tawk_API.onChatMaximized = () => {
          this.hide();
          if (typeof previousOnMaximized === "function") {
            previousOnMaximized();
          }
        };

        window.Tawk_API.onChatMinimized = () => {
          this.show();
          if (typeof previousOnMinimized === "function") {
            previousOnMinimized();
          }
        };
      }
    },
  );
}